module.exports = __webpack_public_path__ + "static/media/i_gstore_fr.ad0cd4bb.svg";